import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { from, Observable } from 'rxjs';
import { environment } from '@environments/environment';

const { apiKey } = environment.googleApi;

@Injectable({
  providedIn: 'root',
})
export class MapLoaderService {
  private readonly _loader = new Loader({ apiKey: apiKey });

  get loader(): Loader {
    return this._loader;
  }

  load(): Observable<typeof google> {
    return from(this._loader.load());
  }
}
